import { render, staticRenderFns } from "./ActiveClass.vue?vue&type=template&id=c3da2394&scoped=true&"
import script from "./ActiveClass.vue?vue&type=script&lang=js&"
export * from "./ActiveClass.vue?vue&type=script&lang=js&"
import style0 from "./ActiveClass.vue?vue&type=style&index=0&id=c3da2394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3da2394",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
